import { useState } from "react";
import * as PR from "../../prime-modules/index";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  AddressElement,
  ExpressCheckoutElement,
  PaymentElement,
  useElements,
  useStripe,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { envConfig } from "../../constants";
import { addressOptions } from "./helper";
import { formatCurrency, getPlanText, showDate } from "../../utils/reuse";
import { useTranslationContext } from "../../context/TranslationContext";
import { CURRENT_PAYMENT_PLAN } from "../../utils/localstore";

export const stripePromise = loadStripe(envConfig.REACT_APP_STRIPE_PUBLIC_KEY);

const PaymentOptions = ({ price, returnUrl, isLoading, setIsLoading }) => {
  const navigate = useNavigate()
  const currentPaymentPlan = JSON.parse(localStorage.getItem(CURRENT_PAYMENT_PLAN))
  const { userData } = useSelector((state) => state.auth);
  const { labelsIot } = useTranslationContext()
  const stripe = useStripe();
  const elements = useElements();
  const { state } = useLocation();

  const [stripeAddressError, setStripeAddressError] = useState("");
  const [billingDetails, setBillingDetails] = useState({});
  const [cardError, setCardError] = useState("");
  const [wallets, setWallets] = useState(false);

  const addressChangeHandler = (event) => {
    setStripeAddressError("");
    if (event.complete) {
      setBillingDetails(event.value);
    } else {
      setBillingDetails({});
    }
  };

  const payHandler =  async () => {
    setIsLoading(true)
    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        payment_method_data: {
          billing_details: billingDetails
        },
        return_url: envConfig.REACT_APP_BASE_URL + returnUrl
      }
    })

    if(!!error) {
      setIsLoading(false);
      setCardError(error?.message)
    } else {
      setIsLoading(false);
    }
  }

  const defaultValues = {
    name: userData.firstName,
    address: {
      country: localStorage.getItem('iot-country-code')
    }
  };

  return (
    <>
          <p className="backto-button" onClick={() => navigate('/plans')} ><i className="pi pi-arrow-left pr-2"></i> {labelsIot?.LBLI0160}</p>
          <h2 className="-mt-3">{labelsIot?.LBLI0104}</h2>
      <div className="card-section">
              <div className="grid w-12">
                <div className="col-12 md:col-6">
                  <h3>{labelsIot?.LBLI0105}</h3>
                  <div className="card flex flex-column mb-4">
                    <PR.InputText
                      name="email"
                      value={userData?.email}
                      placeholder={labelsIot?.LBLI0082}
                      disabled
                    />
                  </div>
                  <AddressElement
                    onChange={addressChangeHandler}
                    options={{ ...addressOptions, defaultValues }}
                  />
                  {stripeAddressError && (
                    <div className="err-msg">{stripeAddressError}</div>
                  )}
                </div>
                <div className="col-12 md:col-6">
                  <h3>{labelsIot?.LBLI0106}</h3>
                  <PaymentElement
                    options={{
                      layout: "tabs",
                      wallets: {
                        applePay: 'never',
                        googlePay: 'never',
                      }
                    }}
                  />
                  <div className="err-msg">{cardError}</div>
                  <div className="card flex flex-column mb-4">
                    <p>
                      {labelsIot?.LBLI0112} <strong>{formatCurrency(state?.priceCurrency, price)}</strong> {labelsIot?.LBLI0113} <strong>{getPlanText(currentPaymentPlan?.duration,currentPaymentPlan?.description,labelsIot)}</strong> {labelsIot?.LBLI0115} <strong>{showDate(state?.subscriptionNextDue)}</strong>
                    </p>
                  </div>
                  <div className="card flex flex-column">
                    <PR.Button
                      label={labelsIot?.LBLI0107}
                      type="button"
                      onClick={payHandler}
                      className="confirm-button"
                      disabled={isLoading}
                    />
                  </div>
                  {wallets && <div>
                  <p>Or Pay with</p>
                  </div>}
                <ExpressCheckoutElement
                    onReady={({availablePaymentMethods}) => {
                      if(availablePaymentMethods) {
                        setWallets(true)
                      }
                    }}
                    onConfirm={payHandler}
                  />
                  <div className="card flex flex-column mt-4">
                    <p className="small_p">
                     {labelsIot?.LBLI0108} <Link target='_blank' to="/terms-and-conditions">{labelsIot?.LBLI0109}</Link> {labelsIot?.LBLI0110} <Link target='_blank' to="/privacy-policy">{labelsIot?.LBLI0111}</Link>
                    </p>
                  </div>
                </div>
              </div>
          </div>
    </>
  );
};

export default PaymentOptions;
